import { jsx as _jsx } from "react/jsx-runtime";
import { useLayoutEffect, useState } from 'react';
// import { _emitter } from '@/shared/io';
import { Loading } from './Loading';
export const LoadingGuard = () => {
    const [open, setOpen] = useState(false);
    useLayoutEffect(() => {
        // _emitter.on('loading', (loading) => {
        //   console.log('-----', loading);
        //   setOpen;
        //   loading;
        // });
        // return () => {
        //   _emitter.all.clear();
        // };
    }, [setOpen]);
    return open ? _jsx(Loading, {}) : null;
};
